import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditComplementoV11Component } from "./edit-complemento-v11/edit-complemento-v11.component";

@Component({
  selector: "app-complementos-v11",
  templateUrl: "./complementos-v11.component.html",
  styleUrls: ["./complementos-v11.component.scss"],
})
export class ComplementosV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditComplementoV11Component;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
